<template>
  <div class="d-flex flex-column" ref="container">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="services"
      :filtersValue="filtersValue"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :sort="sort"
    ></filtered-data>

    <div class="container-fluid" ref="header">
      <div class="d-flex align-items-center">
        <h1 class="mr-auto">Обслуживание</h1>
        <img class="mr-auto" src="~img/service-legend.svg" style="max-width: 900px; width: 100%; margin-bottom: -3px;">
        <btn-filters
          :data="data"
          endpoint="services"
          v-model="filtersValue"
        ></btn-filters>
      </div>
    </div>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        @load-more="$refs.data.loadMore"
        :hasMore="hasMore"
        :loading="loading"
        @sort-change="sortChange"
      >
        <table-column-serial-number sortable="keyword" :fixed="true"/>
        <el-table-column prop="address" label="Адрес установки" min-width="220"/>
        <el-table-column prop="services_planned" label="Плановые сервисы" min-width="1100">
          <template slot-scope="{row}">
            <machine-service-timeline
              :operator="row.operator"
              :tech="row.technician"
              :planned_prop="row.services_planned"
              :performed_prop="row.services_performed"
              :machine_id="row.id"
              :region_id="row.region_id"
            />
          </template>
        </el-table-column>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  export default {
    metaInfo: {title: 'Обслуживание'},
    data () {
      return {
        filtersValue: null,
        data: null,
        loading: false,
        hasMore: true,
        sort: null,
      }
    },
    methods: {
      sortChange (sort) {
        if (sort.prop) {
          const order = sort.order === 'ascending' ? 'asc' : 'desc'
          const sortable = sort.column.sortable

          // set prop name
          let prop = (sortable === 'keyword') ? sort.prop + '.keyword' : sort.prop

          this.sort = `${prop}:${order}`
        } else {
          this.sort = null
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/service.vue